var Languages;
(function(Languages) {
    Languages[Languages["RUS"] = 0] = "RUS";
    Languages[Languages["UKR"] = 1] = "UKR";
    Languages[Languages["ENG"] = 3] = "ENG";
    Languages[Languages["SPA"] = 4] = "SPA";
    Languages[Languages["GERMAN"] = 6] = "GERMAN";
    Languages[Languages["POL"] = 15] = "POL";
    Languages[Languages["FRA"] = 16] = "FRA";
    Languages[Languages["UZB"] = 65] = "UZB";
    Languages[Languages["TURKEY"] = 82] = "TURKEY";
    Languages[Languages["KAZ"] = 97] = "KAZ";
    Languages[Languages["BEL"] = 114] = "BEL";
})(Languages || (Languages = {}));
var Scheme;
(function(Scheme) {
    Scheme["LIGHT"] = 'light';
    Scheme["DARK"] = 'dark';
})(Scheme || (Scheme = {}));

export { Languages, Scheme };
